import { RefObject, useEffect } from "react";

import { IntakeShell } from "./components/IntakeShell";
import { IntakeFooterNav } from "./components/IntakeFooterNav";
import { IntakeCameraPreview } from "./components/IntakeCameraPreview";
import { useIntakeCopy } from "./hooks/useIntakeCopy";

type Props = {
  stream: MediaStream | null;
  videoRef: RefObject<HTMLVideoElement>;
  variant?: "initial" | "after_deeper";
  onBack: () => void;
  onPreview: () => void;
  onGoDeeper?: () => void;
};

export function IntakeWrapUp({
  stream,
  videoRef,
  variant = "initial",
  onBack,
  onPreview,
  onGoDeeper,
}: Props) {
  const { t, progressLabel } = useIntakeCopy();
  const copyKey = variant === "after_deeper" ? "after_deeper" : "initial";

  useEffect(() => {
    const video = videoRef.current;
    if (video && stream) {
      video.srcObject = stream;
      void video.play().catch(() => {});
    }
  }, [stream, videoRef]);

  return (
    <IntakeShell
      progressStep={4}
      progressTotal={5}
      progressLabel={progressLabel(4, 5)}
      footer={
        <IntakeFooterNav
          onBack={onBack}
          backLabel={t("intake.back")}
          primaryLabel={t("intake.wrap_up.preview_launch")}
          onPrimary={onPreview}
          secondaryLabel={
            variant === "initial" && onGoDeeper
              ? t("intake.wrap_up.go_deeper")
              : undefined
          }
          onSecondary={variant === "initial" ? onGoDeeper : undefined}
        />
      }
    >
      <h1 className="intake-flow__headline">
        {t(`intake.wrap_up.${copyKey}.headline`)}
      </h1>
      <p className="intake-flow__subtext intake-flow__subtext--center">
        {t(`intake.wrap_up.${copyKey}.subtext`)}
      </p>

      <IntakeCameraPreview videoRef={videoRef} stream={stream} showRec />
    </IntakeShell>
  );
}
